/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-create-order-stakeholder-post';
import { ApiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-create-order-stakeholder-post';
import { apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-create-order-stakeholder-post-plain';
import { ApiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-create-order-stakeholder-post-plain';
import { apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-delete-order-stakeholder-delete';
import { ApiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-delete-order-stakeholder-delete';
import { apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-delete-order-stakeholder-delete-plain';
import { ApiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-delete-order-stakeholder-delete-plain';
import { apiNurseryManagerOrderStakeholderGetCurrentUserParksPost } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-current-user-parks-post';
import { ApiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-current-user-parks-post';
import { apiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Plain } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-current-user-parks-post-plain';
import { ApiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Plain$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-current-user-parks-post-plain';
import { apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-orders-stakeholder-post';
import { ApiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-orders-stakeholder-post';
import { apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-orders-stakeholder-post-plain';
import { ApiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-orders-stakeholder-post-plain';
import { apiNurseryManagerOrderStakeholderGetOrderStakeholderPost } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-order-stakeholder-post';
import { ApiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-order-stakeholder-post';
import { apiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Plain } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-order-stakeholder-post-plain';
import { ApiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Plain$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-order-stakeholder-post-plain';
import { apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-order-stakeholders-with-data-post';
import { ApiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-order-stakeholders-with-data-post';
import { apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Plain } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-order-stakeholders-with-data-post-plain';
import { ApiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Plain$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-order-stakeholders-with-data-post-plain';
import { apiNurseryManagerOrderStakeholderGetUnitsPost } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-units-post';
import { ApiNurseryManagerOrderStakeholderGetUnitsPost$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-units-post';
import { apiNurseryManagerOrderStakeholderGetUnitsPost$Plain } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-units-post-plain';
import { ApiNurseryManagerOrderStakeholderGetUnitsPost$Plain$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-get-units-post-plain';
import { apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-update-order-stakeholder-patch';
import { ApiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-update-order-stakeholder-patch';
import { apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Plain } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-update-order-stakeholder-patch-plain';
import { ApiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Plain$Params } from '../fn/order-stakeholder/api-nursery-manager-order-stakeholder-update-order-stakeholder-patch-plain';
import { CreateOrderStakeholderCommandResult } from '../models/create-order-stakeholder-command-result';
import { GetCurrentUserParksQueryResult } from '../models/get-current-user-parks-query-result';
import { GetOrdersStakeholderQueryResult } from '../models/get-orders-stakeholder-query-result';
import { GetOrderStakeholderQueryResult } from '../models/get-order-stakeholder-query-result';
import { GetOrderStakeholdersWithDataQueryResult } from '../models/get-order-stakeholders-with-data-query-result';
import { GetUnitsQueryResult } from '../models/get-units-query-result';
import { ToggleActivationOrderStakeholderCommandResult } from '../models/toggle-activation-order-stakeholder-command-result';
import { UpdateOrderStakeholderCommandResult } from '../models/update-order-stakeholder-command-result';

@Injectable({ providedIn: 'root' })
export class OrderStakeholderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiNurseryManagerOrderStakeholderGetUnitsPost()` */
  static readonly ApiNurseryManagerOrderStakeholderGetUnitsPostPath = '/api/NurseryManager/OrderStakeholder/GetUnits';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderGetUnitsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetUnitsPost$Plain$Response(params?: ApiNurseryManagerOrderStakeholderGetUnitsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUnitsQueryResult>> {
    return apiNurseryManagerOrderStakeholderGetUnitsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderGetUnitsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetUnitsPost$Plain(params?: ApiNurseryManagerOrderStakeholderGetUnitsPost$Plain$Params, context?: HttpContext): Observable<GetUnitsQueryResult> {
    return this.apiNurseryManagerOrderStakeholderGetUnitsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUnitsQueryResult>): GetUnitsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderGetUnitsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetUnitsPost$Response(params?: ApiNurseryManagerOrderStakeholderGetUnitsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUnitsQueryResult>> {
    return apiNurseryManagerOrderStakeholderGetUnitsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderGetUnitsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetUnitsPost(params?: ApiNurseryManagerOrderStakeholderGetUnitsPost$Params, context?: HttpContext): Observable<GetUnitsQueryResult> {
    return this.apiNurseryManagerOrderStakeholderGetUnitsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUnitsQueryResult>): GetUnitsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderStakeholderGetCurrentUserParksPost()` */
  static readonly ApiNurseryManagerOrderStakeholderGetCurrentUserParksPostPath = '/api/NurseryManager/OrderStakeholder/GetCurrentUserParks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Plain$Response(params?: ApiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCurrentUserParksQueryResult>> {
    return apiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Plain(params?: ApiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Plain$Params, context?: HttpContext): Observable<GetCurrentUserParksQueryResult> {
    return this.apiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCurrentUserParksQueryResult>): GetCurrentUserParksQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderGetCurrentUserParksPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Response(params?: ApiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCurrentUserParksQueryResult>> {
    return apiNurseryManagerOrderStakeholderGetCurrentUserParksPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetCurrentUserParksPost(params?: ApiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Params, context?: HttpContext): Observable<GetCurrentUserParksQueryResult> {
    return this.apiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCurrentUserParksQueryResult>): GetCurrentUserParksQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderStakeholderGetOrderStakeholderPost()` */
  static readonly ApiNurseryManagerOrderStakeholderGetOrderStakeholderPostPath = '/api/NurseryManager/OrderStakeholder/GetOrderStakeholder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Plain$Response(params?: ApiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderStakeholderQueryResult>> {
    return apiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Plain(params?: ApiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Plain$Params, context?: HttpContext): Observable<GetOrderStakeholderQueryResult> {
    return this.apiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderStakeholderQueryResult>): GetOrderStakeholderQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderGetOrderStakeholderPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Response(params?: ApiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderStakeholderQueryResult>> {
    return apiNurseryManagerOrderStakeholderGetOrderStakeholderPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetOrderStakeholderPost(params?: ApiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Params, context?: HttpContext): Observable<GetOrderStakeholderQueryResult> {
    return this.apiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderStakeholderQueryResult>): GetOrderStakeholderQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost()` */
  static readonly ApiNurseryManagerOrderStakeholderGetOrdersStakeholderPostPath = '/api/NurseryManager/OrderStakeholder/GetOrdersStakeholder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain$Response(params?: ApiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersStakeholderQueryResult>> {
    return apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain(params?: ApiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain$Params, context?: HttpContext): Observable<GetOrdersStakeholderQueryResult> {
    return this.apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrdersStakeholderQueryResult>): GetOrdersStakeholderQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Response(params?: ApiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersStakeholderQueryResult>> {
    return apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost(params?: ApiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Params, context?: HttpContext): Observable<GetOrdersStakeholderQueryResult> {
    return this.apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrdersStakeholderQueryResult>): GetOrdersStakeholderQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost()` */
  static readonly ApiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPostPath = '/api/NurseryManager/OrderStakeholder/GetOrderStakeholdersWithData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Plain$Response(params?: ApiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderStakeholdersWithDataQueryResult>> {
    return apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Plain(params?: ApiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Plain$Params, context?: HttpContext): Observable<GetOrderStakeholdersWithDataQueryResult> {
    return this.apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderStakeholdersWithDataQueryResult>): GetOrderStakeholdersWithDataQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Response(params?: ApiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderStakeholdersWithDataQueryResult>> {
    return apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost(params?: ApiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Params, context?: HttpContext): Observable<GetOrderStakeholdersWithDataQueryResult> {
    return this.apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderStakeholdersWithDataQueryResult>): GetOrderStakeholdersWithDataQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost()` */
  static readonly ApiNurseryManagerOrderStakeholderCreateOrderStakeholderPostPath = '/api/NurseryManager/OrderStakeholder/CreateOrderStakeholder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain$Response(params?: ApiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOrderStakeholderCommandResult>> {
    return apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain(params?: ApiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain$Params, context?: HttpContext): Observable<CreateOrderStakeholderCommandResult> {
    return this.apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateOrderStakeholderCommandResult>): CreateOrderStakeholderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Response(params?: ApiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOrderStakeholderCommandResult>> {
    return apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost(params?: ApiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Params, context?: HttpContext): Observable<CreateOrderStakeholderCommandResult> {
    return this.apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateOrderStakeholderCommandResult>): CreateOrderStakeholderCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch()` */
  static readonly ApiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatchPath = '/api/NurseryManager/OrderStakeholder/UpdateOrderStakeholder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Plain$Response(params?: ApiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOrderStakeholderCommandResult>> {
    return apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Plain(params?: ApiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Plain$Params, context?: HttpContext): Observable<UpdateOrderStakeholderCommandResult> {
    return this.apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateOrderStakeholderCommandResult>): UpdateOrderStakeholderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Response(params?: ApiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOrderStakeholderCommandResult>> {
    return apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch(params?: ApiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Params, context?: HttpContext): Observable<UpdateOrderStakeholderCommandResult> {
    return this.apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateOrderStakeholderCommandResult>): UpdateOrderStakeholderCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete()` */
  static readonly ApiNurseryManagerOrderStakeholderDeleteOrderStakeholderDeletePath = '/api/NurseryManager/OrderStakeholder/DeleteOrderStakeholder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain$Response(params?: ApiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ToggleActivationOrderStakeholderCommandResult>> {
    return apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain(params?: ApiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain$Params, context?: HttpContext): Observable<ToggleActivationOrderStakeholderCommandResult> {
    return this.apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ToggleActivationOrderStakeholderCommandResult>): ToggleActivationOrderStakeholderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Response(params?: ApiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ToggleActivationOrderStakeholderCommandResult>> {
    return apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete(params?: ApiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Params, context?: HttpContext): Observable<ToggleActivationOrderStakeholderCommandResult> {
    return this.apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ToggleActivationOrderStakeholderCommandResult>): ToggleActivationOrderStakeholderCommandResult => r.body)
    );
  }

}
